// start:ng42.barrel
export * from './classic-stay-preferences.model';
export * from './preference.model';
export * from './preference-option.model';
export * from './reservation-stay-preferences.model';
export * from './stay-preference.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/stay-preferences/index.ts